import type { PrismTheme } from "prism-react-renderer";

export const codeTheme: PrismTheme = {
  // Color of text and background.
  plain: { color: "var(--primary-text)", backgroundColor: "var(--main-bg)" },
  styles: [
    {
      // Styles for the appearance of comments.
      types: ["comment"],
      style: { color: "var(--secondary-link)", fontStyle: "italic" },
    },
    {
      types: ["variable", "constant"],
      style: { color: "var(--cogcache-vermilion)" },
    },
    { types: ["punctuation"], style: { color: "var(--primary-text)" } },
    {
      types: ["selector", "doctype"],
      style: { color: "var(--cogcache-emerald)", fontStyle: "italic" },
    },
    {
      types: ["tag", "operator", "keyword"],
      style: { color: "var(--primary-text)" },
    },
    {
      types: [
        "namespace",
        "property",
        "boolean",
        "class-name",
        "builtin",
        "char",
        "function",
        "number",
        "string",
        "url",
      ],
      style: { color: "var(--cogcache-emerald)" },
    },
  ],
};
